/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-11-21",
    versionChannel: "nightly",
    buildDate: "2024-11-21T00:06:20.798Z",
    commitHash: "ed26f40810aa6773a4bff3a62d02c9a7c7979344",
};
